import "magnific-popup";

// IFRAME
function magnificPopupIframe(){
	$('.magnific-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-video-wrapper',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	});
}

// INLINE
function magnificPopupInline(){
	$('.magnific-inline-popup').magnificPopup({
		type: 'inline',
	
		fixedContentPos: false,
		fixedBgPos: true,
	
		overflowY: 'auto',
	
		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

		callbacks: {
			open: function() {
				if ( this.st.el[0].getAttribute('data-value') ) {
					// add value to the browser URL
					window.history.pushState(null, null, '?profile=' + this.st.el[0].getAttribute('data-value'));
				}

				// Add classes to the mfp-content to be able to change the background color of the popup.
				const mfpContent = this.content[0];

				if ( mfpContent.classList.contains('book-popup') ) {
					mfpContent.parentNode.classList.add('mfp-content--book');
				}
				if ( mfpContent.classList.contains('book-alumni-popup') ) {
					mfpContent.parentNode.classList.add('mfp-content--book-alumni');
				}
			},
			close: function() {
				// remove the ?profile from browser URL
				const url = new URL(window.location);

				if ( url.searchParams.has( 'profile' ) ) {
					url.searchParams.delete('profile');
					
					window.history.pushState(null, null, url.toString());
				}
			}
		}
	});

	// Popup with URL linked. On load, we open the popup.
	const profile = window.location.search.match( /profile=(\w+)/gi );
	if ( profile ){
		const popupId = profile[0].split('=')[1];

		// Without the search, we would only be able to open the popups on the first page of the archive.
		const url = `https://www.mansfield.ox.ac.uk/wp-json/wp/v2/team-member?include=${popupId}`
		fetch(url)
			.then(response => response.json())
			.then(data => {
				const personName = data[0].title.rendered;

				const searchInput = document.querySelector( '[name="_sf_search[]"]' )
				if ( personName && searchInput ) {
					searchInput.value = personName;

					const event = new Event('input', { bubbles: true });
					searchInput.dispatchEvent(event);

					const changeEvent = new Event('change', { bubbles: true });
					searchInput.dispatchEvent(changeEvent);

					const enterKeyEvent = new KeyboardEvent('keydown', {
						bubbles: true,
						cancelable: true,
						key: 'Enter',
						code: 'Enter',
						keyCode: 13, // For older browsers
						which: 13    // For older browsers
					});
					searchInput.dispatchEvent(enterKeyEvent);

					// Open the popup
					$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
						document.querySelector(`a[href="#popup-${popupId}"]`)?.click();
					})
				}
			})
			.catch(error =>
				console.error('Error:', error)
			);
	}
}

// GALLERY SINGLE IMAGE
function magnificPopupSingleImage(){
	$('.magnific-gallery-single-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-single',
		image: {
			verticalFit: true,
			titleSrc: function titleSrc(item) {
			return item.el.attr('title');
			}
		},
		gallery: {
			enabled: false
		}
	});          
}

// GALLERY IMAGE
function magnificPopupGalleryImage(){
	$('.magnific-gallery-mode-enabled').each(function() { // the containers for all galleries
		$(this).magnificPopup({
			type: 'image',
			delegate: 'a.magnific-gallery-image',
			closeOnContentClick: true,
			mainClass: 'mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: function(item) {
					return item.el.attr('title');
				}
			},
			gallery: {
				enabled:true
			}
		});
	});
}

export { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage };
